(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/wager-payment-flow/standard-flow/assets/javascripts/standard-payment-flow.js') >= 0) return;  svs.modules.push('/components/wager-payment-flow/standard-flow/assets/javascripts/standard-payment-flow.js'); "use strict";


const {
  createPayment
} = svs.components.wager.payment;
const {
  authenticated
} = svs.components.wager.middleware;
const {
  accountBalanceMW
} = svs.components.wagerPaymentFlow.standardFlow.middlewareSetup;
const createStandardPaymentFlow = async _ref => {
  let {
    wagers
  } = _ref;
  const paymentPromise = await createPayment(wagers).addPreMiddleware(accountBalanceMW).addPreMiddleware(authenticated);
  return paymentPromise;
};
setGlobal('svs.components.wagerPaymentFlow.standardFlow.createStandardPaymentFlow', createStandardPaymentFlow);
 })(window);